export const Page = {
    // 公共页面
    login: 'login',
    reset: 'reset',
    // 管理员页面
    dashboard: 'dashboard',
    accountMgmt: 'accountMgmt',
    accountDetail: 'accountDetail',
    firmware: 'firmware',
    system: 'system',
    stats: 'stats',
    logs: 'logs',
    dynamic: 'dynamic',
    calendar: 'calendar',
    pushMgmt: 'pushMgmt',
    edfTask: 'edfTask',
    ecg: 'ecg',
    ecgShow: 'ecgShow',
    hrvShow: 'hrvShow',

    // 普通用户页面
    userAccountMgmt: 'userAccountMgmt',
    userDynamic: 'userDynamic',

    // 信息页面
    privacyPolicy: 'privacyPolicy',
    termsOfService: 'termsOfService',
    privacy_policy_en: 'privacy_policy_en',
    privacy_policy_zh: 'privacy_policy_zh',
    terms_of_service_en: 'terms_of_service_en',
    terms_of_service_zh: 'terms_of_service_zh',

    // SDK相关页面
    sdkIntro: 'sdkIntro',
    sdkRegister: 'sdkRegister',
    sdkLogin: 'sdkLogin',
    /** sdkMgmt */
    sdkMgmt: 'sdkMgmt',
    sdkTest: 'sdkTest',
    /** sdkDev */
    sdkDev: 'sdkDev',
    sdkDoc: 'sdkDoc'
}